import React from 'react';
import Page from '../components/page';
import { useLocation } from 'react-router-dom';

export default function CustomerPage() {
  const { state } = useLocation();
  const {url,title} = state;
  return (
    <Page navPage className="customer-page" contentClassName="bh-100">
      <iframe title={title} className="customer-iframe" src={url} />
    </Page>
  );
}
